import type { FaireProductEntity } from "../../entity_types/product";

export const p_hg4272janb: FaireProductEntity = {
  token: "p_hg4272janb",
  type: "product",
  name: "Eggplant Memo Pad - Grocery List Notepad",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/5e08c0557cf46bc0fb7d3c9723cb6d1df519d77ceae4f085e3007d0f357f4323.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/741ee1d0526cf5abe253674827de5845ad934205d3543f4bccb5e7fc5a90febd.jpeg"
  ],
  priceDollars: 7,
  description: "Gone are the days of boring stationery and uninspired to-do lists. This Eggplant Grocery List Notepad adds a playful touch to your everyday planning, featuring a bold illustrated eggplant design that looks right at home in any kitchen.\n\nDesigned for life on the fridge, kitchen counter, or desk, this kitchen memo pad makes grocery lists, reminders, and recipe notes a little more fun. It’s a perfect pick for home cooks, veggie lovers, and anyone who enjoys cheerful food-themed stationery.\n\nKeep it handy for market lists, tear off a page for quick notes, or tuck it into your favorite cookbook as a bookmark.\n\nA charming little foodie gift that also merchandises beautifully alongside our sticky notes and notebooks.\n\nGood to know:\n\n• Measures 3.5\" × 8.5\"\n• Printed in full color on high-quality paper\n• Padded with sturdy cardboard backing\n• Packaged in a protective cellophane sleeve with a descriptive sticker on the front\n",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:34:01.597Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
